// Ayuda corta de cada pantalla para el botón (?) del título (#129).
// Clave = ruta de App.jsx (con :parámetros si los tiene). `seccion` es el
// {#id} de su sección en docs/MANUAL_OPERARIO.md, que se abre en /ayuda.
// Pantalla nueva = entrada nueva aquí (docs/ESTANDAR-UI.md §4).
export const AYUDA_PANTALLAS = {
  '/': {
    titulo: 'Inicio',
    resumen: 'La portada del día: acciones rápidas, tareas y metas del mes, saldos, alertas y los reportes principales de la empresa activa.',
    puntos: [
      'Las **acciones rápidas** que piden cliente o proveedor abren primero un buscador por nombre o RIF.',
      'Las **tareas del mes** las calcula el sistema según tu rol; las vencidas van primero.',
      'Las **metas** las carga el gerente: la raya oscura marca lo esperado a hoy (verde va bien, rojo va atrás).'
    ],
    seccion: 'inicio'
  },
  '/bancos/resumen': {
    titulo: 'Resumen de Bancos',
    resumen: 'Tablero de bancos con gráficos de la cuenta elegida, disponibilidad total, pagos próximos y alertas. Solo lectura.',
    puntos: [
      'Arriba a la derecha eliges la cuenta de los gráficos.',
      'Disponibilidad total convierte las cuentas en Bs con la tasa elegida; un clic muestra cada cuenta.',
      'La línea de saldo del gráfico es el acumulado del período, no el saldo real de la cuenta.'
    ],
    seccion: 'bancos-resumen'
  },
  '/cuentas': {
    titulo: 'Cuentas',
    resumen: 'Las cuentas bancarias y de efectivo de la empresa, agrupadas por moneda.',
    puntos: [
      'El saldo actual no se escribe a mano: es el saldo inicial más todos los movimientos.',
      'Si corriges el saldo inicial, el saldo actual se ajusta por la misma diferencia.',
      'Desmarca **Cuenta fiscal** si lo que entra ahí no declara IVA (paralelo).',
      'El **saldo mínimo** activa la alerta; una cuenta que ya no se usa se marca inactiva al editarla y deja de admitir movimientos nuevos (su historial se conserva).',
      'Un clic en una cuenta abre sus movimientos.'
    ],
    seccion: 'cuentas'
  },
  '/movimientos': {
    titulo: 'Movimientos',
    resumen: 'Ingresos, egresos y transferencias de la cuenta elegida en el filtro. Lo que crees va a esa cuenta.',
    puntos: [
      '**+** nuevo movimiento, **⇄** transferencia, **↑** cargar estado de cuenta del banco.',
      'Si ya existe uno con la misma cuenta, fecha y monto, el sistema avisa antes de guardar.',
      'El recibo de un egreso pide una sola vez el nombre de quien recibe; después no se cambia.',
      'Editar y eliminar requiere rol contador. Lo conciliado solo se cambia desde Conciliación.'
    ],
    seccion: 'movimientos'
  },
  '/conciliacion': {
    titulo: 'Conciliación bancaria',
    resumen: 'Comparar el estado de cuenta del banco con los movimientos del sistema, mes por mes, y cerrar el período.',
    puntos: [
      '**Nueva conciliación:** eliges el mes y subes el archivo del banco; la IA lee las líneas.',
      'Confirma los vínculos sugeridos y vincula a mano los pendientes.',
      '**Sugerir parejas con IA:** para los pendientes propone parejas (fecha corrida, referencia, comisión) con su porqué; nada se vincula sin tu ✓.',
      'Solo se cierra con todo conciliado y sin movimientos sin pareja, incluidos los de meses anteriores.'
    ],
    seccion: 'conciliacion'
  },
  '/categorias': {
    titulo: 'Cuentas contables',
    resumen: 'Las categorías de ingresos y egresos (máximo dos niveles) y su clasificación para el Estado de resultados y el Balance.',
    puntos: [
      'La lista de cada fila guarda la clasificación al cambiarla; una subcategoría sin clase hereda la del padre.',
      '"Solo sin clasificar" muestra lo que falta.',
      '**No es gasto** la saca del 100 % en Egresos por categoría.',
      'El **código** (ej. 5.01.03) ordena las categorías en todas partes; **Proponer códigos** llena los que faltan.',
      '**Fusionar** pasa todo lo de una categoría repetida a otra y elimina la repetida.',
      'Pestaña **Reglas automáticas**: "si la descripción o el beneficiario contiene X → esta cuenta". El movimiento nuevo y la importación del estado de cuenta llegan con la categoría puesta (se ve "Por regla" o "Regla"); lo elegido a mano manda.',
      'Si dos reglas coinciden gana la más específica. Una regla nunca cambia una categoría ya puesta salvo que marques "Cambiar también"; los meses cerrados no se tocan.',
      '**Aplicar a los sin categoría** propone por regla (marcadas) y con IA para el resto (sin marcar); revisas antes de aplicar. El cierre avisa "Contra una regla" si un movimiento quedó en otra cuenta.'
    ],
    seccion: 'categorias'
  },
  '/tasas-cambio': {
    titulo: 'Tasas de cambio',
    resumen: 'La tasa BCV y la tasa USD de cada día. Son las mismas para todas las empresas.',
    puntos: [
      'Fecha, BCV y USD son obligatorias; guardar un día ya cargado reemplaza sus valores.',
      'Arriba están los días pendientes; en el calendario, el punto rojo indica que falta alguna tasa.',
      'Clic derecho en un día lo marca como feriado (rojo) o evento (amarillo).',
      'Sin la BCV del día no se guardan facturas en BCV, pagos en Bs ni abre la caja.'
    ],
    seccion: 'tasas'
  },
  '/contabilidad/configuracion': {
    titulo: 'Configuración contable',
    resumen: 'Los datos de agente de retención de la empresa activa y los conceptos de ISLR.',
    puntos: [
      'Lo que marques como agente de retención decide qué se retiene en cada factura de compra.',
      'Cada concepto de ISLR tiene % y sustraendo para persona natural y jurídica; la letra del RIF del proveedor decide cuál se usa.',
      'Los conceptos de ISLR son comunes a todas las empresas y no se borran: se inhabilitan.'
    ],
    seccion: 'configuracion-contable'
  },
  '/ventas': {
    titulo: 'Ventas',
    resumen: 'Tablero de ventas: facturas menos notas de crédito, más los tickets de caja. Montos sin IVA.',
    puntos: [
      'Eliges el período y la moneda (BCV o USD).',
      'El ícono de ajustes (gerente o más) prende, apaga y ordena los bloques para **toda la empresa**.',
      'Exportar da un Excel con una hoja por bloque.'
    ],
    seccion: 'ventas'
  },
  '/clientes': {
    titulo: 'Clientes',
    resumen: 'La ficha de cada cliente con su estado de cuenta: facturas, cobranzas, anticipos y notas.',
    puntos: [
      'Elige un cliente para ver su estado de cuenta; ahí están **Registrar pago**, **Nota de crédito / débito** y **Nueva factura**.',
      'El estado de cuenta se baja en Excel o PDF o se envía por correo con los filtros elegidos.',
      'Los pagos usan las tasas del día del pago; lo que sobra queda como anticipo.'
    ],
    seccion: 'clientes'
  },
  '/vendedores': {
    titulo: 'Vendedores',
    resumen: 'Vendedores externos (sin acceso al sistema) que cobran comisión por las ventas de sus clientes asignados.',
    puntos: [
      'Elige un vendedor para ver su matriz de comisión, sus clientes y sus liquidaciones.',
      'Eliminar un vendedor solo se puede si no tiene clientes asignados.'
    ],
    seccion: 'vendedores'
  },
  '/vendedores/:id': {
    titulo: 'Detalle de vendedor',
    resumen: 'Matriz de comisión (por producto y tipo de precio), clientes asignados y liquidaciones de un vendedor.',
    puntos: [
      'La **matriz** define cuánto gana el vendedor por producto, según se vendió a precio detal, mayor o fábrica, en % o monto fijo por unidad.',
      'El tipo de precio de cada venta se infiere comparando lo cobrado contra la lista de precios del producto; sin coincidencia se asume **detal**.',
      'La comisión solo se calcula sobre facturas ya **pagadas**. "Generar liquidación" junta todo lo pendiente hasta hoy; no hay período fijo.',
      'Una venta de un producto sin regla configurada se avisa pero no se puede liquidar todavía.'
    ],
    seccion: 'vendedores'
  },
  '/clientes/:clienteId/factura/nueva': {
    titulo: 'Factura de venta',
    resumen: 'Cargar una factura de venta. El número se propone solo y no puede repetirse.',
    puntos: [
      'Una línea sin producto necesita categoría de venta.',
      'Arranca **no fiscal**: marca "Documento fiscal" para que lleve IVA, número de control y vaya al Libro de Ventas.',
      'Una factura en BCV necesita la tasa BCV de su fecha.'
    ],
    seccion: 'factura-venta'
  },
  '/clientes/:clienteId/factura/:facturaId': {
    titulo: 'Editar factura de venta',
    resumen: 'Corregir una factura de venta. Una factura anulada ya no se edita.',
    puntos: [
      'Una línea sin producto necesita categoría de venta.',
      'Si cambias el total, revisa que sus pagos no la dejen sobrepagada.'
    ],
    seccion: 'factura-venta'
  },
  '/clientes/:clienteId/nota/:tipo/:afectadaId': {
    titulo: 'Nota de crédito o débito',
    resumen: 'Una nota sobre una factura anterior. Siempre es fiscal y arranca con las líneas de esa factura.',
    puntos: [
      'Deja solo las líneas y montos que corrige la nota.',
      'Al guardarla cambia el saldo de la factura afectada.'
    ],
    seccion: 'factura-venta'
  },
  '/proveedores': {
    titulo: 'Proveedores',
    resumen: 'La ficha de cada proveedor con sus facturas de compra, pagos, anticipos y retenciones.',
    puntos: [
      'La **cámara** carga una factura desde foto o PDF con IA; revisa los datos antes de guardar.',
      'El N° de factura del proveedor es obligatorio y no se repite para ese proveedor.',
      'Si la empresa es agente de retención, las retenciones se calculan y numeran solas.',
      'El botón **%** junto a editar define qué se le retiene al proveedor (IVA, concepto ISLR, municipal); sus facturas nuevas lo traen puesto.',
      'Cada línea con producto actualiza el costo de ese producto.'
    ],
    seccion: 'proveedores'
  },
  '/proveedores/recurrentes': {
    titulo: 'Facturas recurrentes',
    resumen: 'Plantillas de facturas de compra que se repiten, como un alquiler.',
    puntos: [
      '**Automático:** la factura se crea sola. **Recordatorio:** avisa en "Pendientes por confirmar".',
      'Las automáticas se generan cuando alguien entra al sistema, una vez por día.',
      'Una plantilla con facturas generadas no se elimina, se inhabilita.'
    ],
    seccion: 'recurrentes'
  },
  '/proveedores/comparador-precios': {
    titulo: 'Comparador de precios',
    resumen: 'A qué precio vendió cada proveedor un mismo insumo, convertido con las tasas del día de cada compra.',
    puntos: [
      'Elige el insumo; solo salen productos con compras a proveedor.',
      'El más barato lleva la marca "Más barato" y los demás dicen cuánto más caros son.'
    ],
    seccion: 'comparador-precios'
  },
  '/caja': {
    titulo: 'Caja',
    resumen: 'El punto de venta: entras con tu PIN, abres el turno, vendes, cobras y al final cierras con arqueo.',
    puntos: [
      'Sin la tasa BCV de hoy la caja no abre.',
      'Si pagan de más, eliges si es propina o vuelto.',
      'Sin internet se sigue vendiendo y los tickets se envían solos al volver; no cierres con tickets sin sincronizar.',
      'Guarda el arqueo antes de cerrar. El operador cierra el turno que abrió; un contador o superior, cualquiera.'
    ],
    seccion: 'caja'
  },
  '/caja/resumen': {
    titulo: 'Resumen del día de caja',
    resumen: 'Lo vendido en un día, por turno y en total. Solo lectura.',
    puntos: [
      'Una pestaña por turno y otra con el total del día.',
      '**Paralelo** = cobrado en efectivo o en una cuenta no fiscal; su IVA no se declara.',
      'Un clic en un ticket muestra sus productos y pagos.'
    ],
    seccion: 'caja-resumen'
  },
  '/caja/configuracion': {
    titulo: 'Configuración de caja',
    resumen: 'Cajeros, formas de pago y plataformas de delivery.',
    puntos: [
      'El PIN del cajero es de 4 dígitos y no puede repetirse.',
      'Cada forma de pago puede ir a una cuenta bancaria: un POS = una cuenta.',
      'Lo que ya se usó en ventas no se elimina: se desactiva.'
    ],
    seccion: 'caja-configuracion'
  },
  '/reportes/cierre-fiscal-diario': {
    titulo: 'Cierre fiscal diario',
    resumen: 'El reporte Z de cada máquina fiscal. Cada cierre es una línea del Libro de Ventas.',
    puntos: [
      'Carga un cierre por máquina por día.',
      'El IVA no se calcula solo: cópialo del Z.',
      'Editar y eliminar requiere rol contador.'
    ],
    seccion: 'cierre-fiscal'
  },
  '/productos': {
    titulo: 'Productos',
    resumen: 'El catálogo de productos, insumos y actividades, organizado en grupos.',
    puntos: [
      'El ícono **$** registra el costo y muestra los precios por proveedor.',
      'Las actividades (mano de obra, carga fabril) se crean con disponibilidad "Contable / administrativo".',
      'Eliminar un producto borra también sus costos, precios, conteos y sus líneas en otras recetas.'
    ],
    seccion: 'productos'
  },
  '/productos/categorizar': {
    titulo: 'Categorizar productos',
    resumen: 'Asignar a cada producto que se compra su cuenta contable de egreso.',
    puntos: [
      'Elige la cuenta a la derecha y arrastra los productos al centro.',
      'La X de un producto en el centro le quita la categoría.'
    ],
    seccion: 'categorizar'
  },
  '/inventario/estructura-costo': {
    titulo: 'Estructura de costo',
    resumen: 'La receta de cada producto, su costo en vivo, la simulación y sus precios de venta con margen.',
    puntos: [
      '**+ Agregar línea** suma un componente o un costo manual al grupo elegido.',
      'Si a un componente le falta costo, el costo en vivo sale incompleto.',
      'La caja toma el precio **Detal en BCV**.'
    ],
    seccion: 'costos-precios'
  },
  '/inventario/grupos-costo': {
    titulo: 'Grupos de estructura de costo',
    resumen: 'Los bloques en que se agrupan las líneas de las recetas y el orden en que se muestran.',
    puntos: ['Al eliminar un grupo, sus líneas quedan "Sin grupo".'],
    seccion: 'costos-precios'
  },
  '/inventario/simulacion': {
    titulo: 'Simulación de costo',
    resumen: 'Probar cambios de costo sin tocar los datos reales y guardarlos como escenarios.',
    puntos: [
      '**Guardar** no cambia nada real.',
      '**Aplicar** crea costos reales con fecha de hoy y afecta a todos los productos que usan ese componente.'
    ],
    seccion: 'simulacion'
  },
  '/inventario/lista-precios': {
    titulo: 'Lista de precios',
    resumen: 'Armar un cuadro de precios para clientes, sin costos ni márgenes.',
    puntos: [
      'Agrega productos con un clic, ordénalos arrastrando y prende los precios que quieras mostrar.',
      'Se exporta a Excel o como imagen. La lista no se guarda al recargar.'
    ],
    seccion: 'lista-precios'
  },
  '/inventario/actual': {
    titulo: 'Inventario actual',
    resumen: 'El inventario valorizado a una fecha: el último cierre o ajuste de cada producto, más compras y menos ventas facturadas desde ese día.',
    puntos: [
      'Las notas de crédito devuelven unidades; las facturas anuladas no cuentan.',
      'La producción no entra: la corrige el próximo cierre o ajuste.',
      'Los productos nunca contados no aparecen.',
      'Un producto sin costo dice "sin costo" y no suma.'
    ],
    seccion: 'inventario-actual'
  },
  '/inventario/cierre': {
    titulo: 'Cierre de inventario',
    resumen: 'Los conteos físicos, guardados como documentos numerados (cierres o ajustes).',
    puntos: [
      'Se carga la **cantidad final contada**, también en un ajuste. Un 0 cuenta; un campo vacío no.',
      'Cada documento tiene su número fecha-NN y nunca sobrescribe a otro.',
      'El ojo muestra la valorización a la fecha del cierre y a costo actual.'
    ],
    seccion: 'cierre-inventario'
  },
  '/reportes/costo-actividades': {
    titulo: 'Costo real de actividades',
    resumen: 'Compara, mes a mes, el costo a mano de cada actividad con el que sale de los gastos reales. No cambia ningún costo.',
    puntos: [
      'Asigna a cada actividad su categoría de gasto (contador o más).',
      'Costo real = gasto de la categoría ÷ kg producidos o unidades vendidas.',
      'En rojo, cuando lo real supera lo escrito a mano en más de 10 %.'
    ],
    seccion: 'costo-actividades'
  },
  '/produccion': {
    titulo: 'Producción',
    resumen: 'Los kg de extrusión por turno y por máquina. El mes de producción va del 16 al 15.',
    puntos: [
      'Arriba están los turnos sin cargar de los últimos 14 días; un clic los abre.',
      'En el calendario: verde cargado, rojo sin cargar, gris no trabajado.'
    ],
    seccion: 'produccion'
  },
  '/produccion/cargar': {
    titulo: 'Cargar producción',
    resumen: 'Los kg de cada máquina para una fecha y un turno.',
    puntos: [
      'Hay un solo registro por fecha y turno; guardar reemplaza sus kg y un campo vacío cuenta como 0.',
      '**No trabajado** marca el turno sin producción; si luego cargas kg, se revierte.'
    ],
    seccion: 'produccion'
  },
  '/produccion/estimaciones': {
    titulo: 'Estimaciones',
    resumen: 'Cuántos kg se dejaron de producir respecto del promedio reciente.',
    puntos: [
      'Lo esperado pondera 7, 30 y 182 días de cada máquina.',
      'Un turno cargado cuenta déficit solo si quedó bajo el 80 % de lo esperado.'
    ],
    seccion: 'estimaciones'
  },
  '/reportes': {
    titulo: 'Reportes',
    resumen: 'El índice de todos los reportes por tema. Todos son de la empresa activa.',
    puntos: [
      'El buscador ignora tildes.',
      'Los que salen en gris con "pronto" todavía no existen.'
    ],
    seccion: 'reportes'
  },
  '/reportes/flujo-caja': {
    titulo: 'Flujo de caja',
    resumen: 'Entradas y salidas reales por mes, con el saldo al cierre de cada mes.',
    puntos: [
      'Las transferencias entre cuentas propias no cuentan.',
      'Un asterisco (*) en el saldo indica que faltó una tasa.',
      'Los movimientos en Bs de días sin tasa no suman.'
    ],
    seccion: 'flujo-caja'
  },
  '/reportes/flujo-proyectado': {
    titulo: 'Flujo proyectado',
    resumen: 'El saldo de hoy más lo que falta cobrar menos lo que falta pagar, a 7, 15, 30 y 90 días.',
    puntos: [
      'Los cobros se esperan con el atraso promedio de cada cliente.',
      'Los pagos van en su fecha de la Agenda de pagos o en su vencimiento.',
      'Avisa en rojo el día en que el saldo caería bajo el mínimo.'
    ],
    seccion: 'flujo-proyectado'
  },
  '/reportes/movimientos-inusuales': {
    titulo: 'Movimientos duplicados o inusuales',
    resumen: 'Casos para revisar: posibles duplicados y montos fuera de lo normal.',
    puntos: [
      'Duplicado = misma cuenta, tipo, monto y fecha.',
      'Inusual = 3 veces o más el promedio de su categoría en 180 días.',
      '**Revisado** saca el caso de la lista.'
    ],
    seccion: 'movimientos-inusuales'
  },
  '/reportes/actividad-usuario': {
    titulo: 'Actividad por usuario',
    resumen: 'Cuánto creó, editó, anuló o eliminó cada usuario en movimientos, facturas y pagos.',
    puntos: ['Un clic en un usuario muestra el detalle de lo que hizo.'],
    seccion: 'actividad-usuario'
  },
  '/reportes/egresos-categoria': {
    titulo: 'Egresos por categoría',
    resumen: 'Cómo se reparte el 100 % de las salidas de un mes.',
    puntos: [
      'Un clic en una categoría abre sus movimientos del mes.',
      'Las categorías "No es gasto" salen aparte; las transferencias no entran.',
      'Si faltan tasas, puedes cargarlas desde el aviso amarillo.'
    ],
    seccion: 'egresos-categoria'
  },
  '/reportes/cuentas-por-pagar': {
    titulo: 'Cuentas por pagar',
    resumen: 'Las facturas de compra pendientes, una por una, y la agenda de pagos a proveedores.',
    puntos: [
      'Arrastra una factura pendiente a la zona de pago para programarla.',
      'Cada fecha pasa por Borrador, Aprobada y Enviada; el correo va al correo de tesorería de la empresa.',
      'La antigüedad de la deuda está en Reportes → Compras.'
    ],
    seccion: 'cxp'
  },
  '/reportes/antiguedad-por-pagar': {
    titulo: 'Antigüedad de cuentas por pagar',
    resumen: 'Antigüedad de lo que se les debe a los proveedores, contada desde el vencimiento de cada factura.',
    puntos: [
      'Un clic en un tramo filtra la tabla; un clic en un proveedor muestra sus facturas.',
      'Usa las tasas que quedaron fijas en cada factura.'
    ],
    seccion: 'cxp'
  },
  '/reportes/cuentas-por-cobrar': {
    titulo: 'Cuentas por cobrar',
    resumen: 'Las facturas de venta pendientes de cobro, una por una y por cliente.',
    puntos: [
      'Cada factura muestra su saldo, el vencimiento y los días vencidos.',
      'La antigüedad por tramos está en Reportes → Ventas.'
    ],
    seccion: 'cxc'
  },
  '/reportes/antiguedad-por-cobrar': {
    titulo: 'Antigüedad de cuentas por cobrar',
    resumen: 'Antigüedad de lo que deben los clientes, contada desde el vencimiento de cada factura.',
    puntos: [
      'Un clic en un tramo filtra la tabla; un clic en un cliente muestra sus facturas.',
      'Usa las tasas que quedaron fijas en cada factura.'
    ],
    seccion: 'cxc'
  },
  '/impuestos': {
    titulo: 'Impuestos',
    resumen: 'Las declaraciones que vencen en el mes (IVA retenido por quincena, IVA del mes, ISLR, municipal e IGTF) con su monto en Bs, vencimiento y estado.',
    puntos: [
      'Pulsá una fila para ver de dónde sale el monto y sus acciones.',
      '**Cerrar quincena** (IVA retenido): desde el día siguiente al fin de la quincena; después nadie carga, edita ni anula retenciones de IVA de esa quincena.',
      '**Marcar declarada** guarda el monto y el Nº de planilla. **Marcar pagada** pide el egreso con que se pagó.',
      'Pasa a **Pagada** sola cuando hay un único egreso en una cuenta en Bs por el monto exacto.',
      'Solo gerente o admin reabre, con motivo; queda en Auditoría.',
      '**Calendario SENIAT**: las fechas del año según el último dígito del RIF. Sin cargar, la pantalla usa una fecha estimada (con *).',
      'El IVA del mes resta el excedente del mes anterior. Las facturas en dólares se pasan a Bs con su tasa BCV.',
      'Debajo: resumen del mes que se declara, Retenciones y los dos libros.'
    ],
    seccion: 'libros'
  },
  '/reportes/libro-ventas': {
    titulo: 'Libro de Ventas',
    resumen: 'Formato SENIAT: facturas de venta fiscales no anuladas y cierres Z.',
    puntos: ['"Fuera del libro fiscal" muestra los documentos no fiscales.'],
    seccion: 'libros'
  },
  '/reportes/libro-compras': {
    titulo: 'Libro de Compras',
    resumen: 'Formato SENIAT: facturas y notas de compra fiscales no anuladas.',
    puntos: ['"Fuera del libro fiscal" muestra los documentos no fiscales.'],
    seccion: 'libros'
  },
  '/reportes/retenciones': {
    titulo: 'Retenciones',
    resumen: 'Las retenciones de IVA, ISLR y municipal de las facturas de compra, para enterar.',
    puntos: [
      'Usa los botones "Quincena anterior" y "Quincena actual".',
      'Pulsá una fila para abrir el comprobante: ver o descargar el PDF, enviarlo o corregir número, fecha, base, % y monto.',
      'No incluye facturas anuladas.'
    ],
    seccion: 'libros'
  },
  '/reportes/estado-resultados': {
    titulo: 'Estado de resultados',
    resumen: 'Ganancia o pérdida del período sobre lo cobrado y pagado, según la clasificación de cada categoría.',
    puntos: [
      'Si hay movimientos sin clasificar, el aviso lleva a Cuentas contables.',
      'Préstamos, activo fijo y socios van aparte, fuera del resultado.'
    ],
    seccion: 'estado-resultados'
  },
  '/reportes/balance-general': {
    titulo: 'Balance general',
    resumen: 'Balance simplificado a una fecha de corte. El patrimonio cierra por diferencia, así que siempre cuadra.',
    puntos: [
      'El inventario sale del último cierre de inventario.',
      'Revisa los avisos: tasa faltante, sin cierre de inventario o movimientos sin clasificar.'
    ],
    seccion: 'balance-general'
  },
  '/reportes/cierre': {
    titulo: 'Cierre mensual o anual',
    resumen: 'Todo el mes o el año en una página: revisión previa, bancos, resultados, balance y lo por cobrar y pagar.',
    puntos: [
      'En un mes: "Empezar cierre" muestra la lista de lo que falta; cada punto se pone verde al corregirse o marcándolo "Revisado" con una nota.',
      '"Cerrar mes" (gerente o admin) solo se activa con todo en verde y bloquea todo lo que tenga fecha de ese mes o anterior.',
      'Solo gerente o admin reabre el último mes cerrado, con motivo.',
      '**Análisis del mes (IA):** compara cada partida con el mes anterior y el promedio de 3 meses y avisa qué mirar.',
      '**Revisión con IA:** arranca al empezar el cierre; cada hallazgo se acepta (✓) o descarta (✕). Aceptar una categoría sugerida la cambia; el resto no toca el movimiento.',
      'Cada bloque abre su reporte completo con las mismas fechas.'
    ],
    seccion: 'cierre-periodo'
  },
  '/auditoria': {
    titulo: 'Auditoría',
    resumen: 'El registro de todo lo que se hizo: quién, cuándo, desde dónde y el antes y después.',
    puntos: [
      'El buscador exige cada palabra: "08/08 taxi" trae lo que tiene esa fecha **y** taxi.',
      'Exportar a Excel baja todas las páginas de la búsqueda.'
    ],
    seccion: 'auditoria'
  },
  '/configuracion': {
    titulo: 'Configuración',
    resumen: 'Usuarios e integraciones de la empresa activa.',
    puntos: [
      'Aprueba las solicitudes de acceso eligiendo el rol.',
      'Invitar no exige que la persona haya entrado antes.',
      'Antes de migrar a QuickBooks, confirma que la compañía conectada sea la correcta.',
      'Comparar con QuickBooks solo lee: muestra qué falta o ya existe, sin cambiar nada.',
      'Facturas 2026 (Excel): marca en cada una si era BCV, USD o BS antes de migrarla.'
    ],
    seccion: 'configuracion'
  },
  '/administracion': {
    titulo: 'Administración',
    resumen: 'Empresas, módulos y permisos de cada usuario. No depende de la empresa activa.',
    puntos: [
      'En Empresas eliges los módulos habilitados de cada una.',
      'En Usuarios das el rol por empresa y ocultas secciones o módulos a una persona.'
    ],
    seccion: 'administracion'
  }
};

// Busca la ayuda de una ruta: primero exacta y después por patrón
// (las rutas con :parámetros, como la factura de un cliente).
export function ayudaDeRuta(pathname) {
  const ruta = (pathname || '/').replace(/\/+$/, '') || '/';
  if (AYUDA_PANTALLAS[ruta]) return AYUDA_PANTALLAS[ruta];
  const clave = Object.keys(AYUDA_PANTALLAS).find((k) => {
    if (!k.includes(':')) return false;
    const patron = new RegExp(`^${k.replace(/:[^/]+/g, '[^/]+')}$`);
    return patron.test(ruta);
  });
  return clave ? AYUDA_PANTALLAS[clave] : null;
}
